<template>
  <a-flex vertical gap="middle">
    <a-typography-text class="req-title">Все обращения</a-typography-text>

    <a-flex align="center" justify="end" gap="middle">
      <a-typography-text class="my-req-title">
        Показывать обращения всех администраторов:
      </a-typography-text>
      <a-switch
        v-model:checked="supportAdminStore.showAllRequests"
        @change="changeRequestsScope"
      />
    </a-flex>

    <BaskitAccordion
      header-field="statusName"
      key-field="status"
      :items="supportAdminStore.groupedRequestsByStatus"
      style="width: 100%; min-width: 235px"
      v-model:expandedPanelKey="selectedRequestsGroupKey"
    >
      <template #panelData="{ item }">
        <SupportAdminRequest :group="item" />
      </template>

      <template #headerData="{ item }">
        <SupportRequestsGroupHeader
          :header="item.statusName"
          :newMessagesCount="
            chatStore.unreadGroupsMessagesCount[item.status as RequestStatus]!
          "
          style="flex-grow: 1"
        />
      </template>
    </BaskitAccordion>
  </a-flex>
</template>

<script setup lang="ts">
import { useSupportAdminStore } from "@/stores/support/support-admin.store";
import { watchEffect, ref } from "vue";
import SupportAdminRequest from "@/components/settings/support/admin/requests/SupportAdminRequest.vue";
import BaskitAccordion from "@/components/UI/BaskitAccordion.vue";
import { useChatStore } from "@/stores/chat/chat.store";
import type { RequestStatus } from "@/api/api.dto";
import { debounce } from "@/tools/debounce";
import SupportRequestsGroupHeader from "@/components/settings/support/SupportRequestsGroupHeader.vue";

const supportAdminStore = useSupportAdminStore();
const chatStore = useChatStore();

const selectedRequestsGroupKey = ref<RequestStatus | null>(null);

const changeRequestsScope = debounce(supportAdminStore.fetchAllAdminChats, 600);

watchEffect(() => {
  const currentRequest = chatStore.currentRequest;
  if (!currentRequest) return;
  selectedRequestsGroupKey.value = chatStore.currentSelectedStatus;
});
</script>

<style scoped lang="scss">
.req-title {
  font-size: 15px;
}
</style>
